import { Directive, HostBinding } from '@angular/core';

@Directive({
  selector: 'glxy-empty-state-title, [glxyEmptyStateTitle]',
  standalone: false,
})
export class EmptyStateTitleDirective {
  @HostBinding('class') class = 'glxy-empty-state-title';
}
